module.exports = __webpack_public_path__ + "static/img/7.2434bcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Events/Mas/Mas-pics/7.jpg
// module id = TbFu
// module chunks = 0